export enum ProductsSearchModesEnum {
  SEARCH = 'search',
  PREVIEW = 'preview',
  LIST = 'list'
}
